import { Dialog, DialogActions, DialogContent, IconButton, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { CommonDialogProps } from './_props'
import { sxs } from './_sxs'

export const CommonDialog = ({ title, subtitle, onClose, ...props }: CommonDialogProps) => (
    <Dialog
        {...props}
        onClose={onClose}
        PaperProps={{
            sx: sxs.dialogPaper,
        }}
    >
        <DialogContent sx={sxs.dialogContent}>
            <Stack sx={sxs.dialogHeader}>
                <Stack>
                    <Typography sx={sxs.dialogTitle}>{title}</Typography>
                    {subtitle && <Typography sx={[sxs.dialogTitle, sxs.dialogSubtitle]}>{subtitle}</Typography>}
                </Stack>
                <DialogActions>
                    <IconButton sx={sxs.dialogCloseButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogActions>
            </Stack>
            {props.children}
        </DialogContent>
    </Dialog>
)
